<template>
  <div>

    <p v-if="message !== null">
      {{message}}
    </p>

    <template v-if="info !== null">
      <dl class="row">
        <dt class="col-sm-2">Id</dt>
        <dd class="col-sm-10">{{info.id}}</dd>

        <dt class="col-sm-2">Login</dt>
        <dd class="col-sm-10">{{info.login}}</dd>

        <dt class="col-sm-2">Reg. time</dt>
        <dd class="col-sm-10">{{info.regTime | getMomentStr}}</dd>

        <dt class="col-sm-2">Role</dt>
        <dd class="col-sm-10">{{info.role | getRoleName}}</dd>
      </dl>

      <ul class="userActionList">
        <li v-show="mayEditUserInfo">
          <router-link
            :to="{name: 'user_edit', params: {userId: info.id}}"
          >
            Edit
          </router-link>
        </li>
        <li v-if="mayChangePassword">
          <router-link
            :to="{name: 'user_change_password', params: {userId: info.id}}"
          >
            Change password
          </router-link>
        </li>
      </ul>
    </template>

    <loading-indicator
      v-if="isLoading"
    />

 </div>
</template>

<script>
import auth from '../auth';
import { HTTP } from '../http-common';

import { LOAD_STATE_INIT    } from '../util';
import { LOAD_STATE_LOADING } from '../util';
import { LOAD_STATE_LOADED  } from '../util';

import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';

import { mayEditUserInfo   as utilMayEditUserInfo   } from '../util';
import { mayChangePassword as utilMayChangePassword } from '../util';

export default {
  name: 'UserInfo',

  components: {
    LoadingIndicator,
  },

  props: {
    userId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      actor: auth.getViewer(),
      loadState: LOAD_STATE_INIT,
      info: null,
    };
  },

  computed: {
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    isLoaded() {
      return this.loadState === LOAD_STATE_LOADED;
    },

    message() {
      if(this.isLoaded && this.info === null) {
        return 'User not found.';
      }
      return null;
    },

    mayEditUserInfo() {
      return utilMayEditUserInfo(this.actor.role);
    },
  
    mayChangePassword() {
      return utilMayChangePassword(this.actor, this.userId);
    },
  },

  watch: {
    userId() {
      this.loadUser();
    },
  },

  created() {
    this.loadUser();
  },

  methods: {
    loadUser() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const url = `/user/${this.userId}/info`;
      HTTP.get(url)
      .then(response => {
        this.info = response.data.data;
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      })
      .finally(() => {
        this.loadState = LOAD_STATE_LOADED;
      });
    },
  },
};
</script>

<style scoped>
  ul.userActionList {
    list-style-type: none;
    padding-left: 0;
  }
</style>
